module.exports = __webpack_public_path__ + "media/components/assets/img/pic/blank/dashboard-400fce77d147fc79d954d30727e238b6.svg";